export default "__VITE_ASSET__BbgXWN2W__"